import { ContactType } from '../enums/contactType'

export const contactTypeToTKey: Record<ContactType, string> = {
  [ContactType.Company]: 'create_contact_modal.contact_type.company',
  [ContactType.Person]: 'create_contact_modal.contact_type.person',
}
